import React from 'react'
import TreatmentGrid from '../../Components/TreatmentGrid'

const Treatments = () => {
  return (<>
    <TreatmentGrid />
    </>)
}

export default Treatments